<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="cpytxt1"><a id="page_iv"></a><span class="smallcaps">CHOKE</span>. Copyright © 2006 by Darnella Ford. All rights reserved. Printed in the United States of America. No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case of brief quotations embodied in critical articles or reviews. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="cpytxt1"><a href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></p>
<p class="cpytxt1">Design by Patrice Sheridan</p>
<p class="cpytxt1">LIBRARY OF CONGRESS CATALOGING-IN-PUBLICATION DATA</p>
<p class="para"> </p>
<p class="cpytxt2">Ford, Darnella.</p>
<p class="cpytxt3">Choke / Darnella Ford.—1st ed.</p>
<p class="cpytxt3">      p. cm.</p>
<p class="cpytxt3">ISBN 0-312-34803-7</p>
<p class="cpytxt3">EAN 978-0-312-34803-8</p>
<p class="cpytxt3">1. African American women—Fiction. 2. Single mothers—Fiction. 3. Mothers and daughters—Fiction. 4. El Mirage (Ariz.)—Fiction. 5. Domestic fiction. I. Title.</p>
<p class="para"> </p>
<p class="cpytxt2">  PS3606.O73C48 2006</p>
<p class="cpytxt2">  813'.6—dc22</p>
<p class="cpytxt4">2006041997</p>
<p class="cpytxt1">First Edition: June 2006</p>
<p class="cpytxt1">10  9  8  7  6  5  4  3  2  1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?7fbca0c8